/** Outcome of a bill: booked (points, balance, savings, stamp, rewards, tier) or queued offline. */
import type { PosTransactionResult } from "../api-types";
import { h } from "../dom-helpers";
import type { RenderedScreen, ScannerApp } from "../scanner-app-context";
import { strings } from "../strings";

function row(label: string, value: string, testId: string): HTMLElement {
  return h("div", { className: "stat" }, h("span", { className: "stat-label" }, label), h("strong", { "data-testid": testId }, value));
}

export function renderResult(app: ScannerApp, result: PosTransactionResult | null, queued: boolean): RenderedScreen {
  const next = h("button", { type: "button", className: "primary big", onclick: () => app.navigate({ name: "scan" }) }, strings.resultNext);

  if (queued || !result) {
    return {
      el: h(
        "section",
        { className: "card stack" },
        h("h2", { "data-testid": "result-title" }, strings.resultQueuedTitle),
        h("p", { className: "muted" }, strings.resultQueuedNote),
        next,
      ),
    };
  }

  const brandName = (id: string) => app.brands.find((b) => b.id === id)?.name ?? id;
  return {
    el: h(
      "section",
      { className: "card stack success" },
      h("h2", { "data-testid": "result-title" }, strings.resultTitle),
      result.replayed ? h("p", { className: "notice", "data-testid": "result-replayed" }, strings.resultReplayed) : null,
      h("p", { className: "points-earned", "data-testid": "points-earned" }, strings.resultPointsEarned(result.pointsEarned)),
      h(
        "div",
        { className: "stats" },
        row(strings.resultNewBalance, strings.points(result.newBalance), "new-balance"),
        row(strings.resultSaved, strings.czk(result.savedCzk), "saved-czk"),
        result.newStampBrandId ? row(strings.resultNewStamp, brandName(result.newStampBrandId), "new-stamp") : null,
      ),
      result.rewardsGranted.length > 0
        ? h("div", {}, h("h3", {}, strings.resultRewards), h("ul", {}, ...result.rewardsGranted.map((r) => h("li", {}, r))))
        : null,
      result.tierChanged ? h("p", { className: "notice", "data-testid": "tier-changed" }, strings.resultTierChanged(strings.tierName[result.tier])) : null,
      next,
    ),
  };
}
